import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import CustomCursor from "./components/CustomCursor";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import PhilosophySection from "./components/PhilosophySection";
import ApproachSection from "./components/ApproachSection";
import PrinciplesSection from "./components/PrinciplesSection";
import ExpertisesSection from "./components/ExpertisesSection";
import TeamSection from "./components/TeamSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import TarifsPage from "./components/TarifsPage";

/** Scroll to hash anchor after navigation (e.g. /tarifs -> /#contact) */
const ScrollToHash = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [hash]);
  return null;
};

const Home = () => (
  <div className="kairos-app grain-overlay">
    <CustomCursor />
    <Header />
    <main>
      <HeroSection />
      <PhilosophySection />
      <ApproachSection />
      <PrinciplesSection />
      <ExpertisesSection />
      <TeamSection />
      <ContactSection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tarifs" element={<TarifsPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
